import moment from "moment";
import classNames from "classnames";
import React from "react";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./DateDisplay.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class DateDisplay extends React.Component {
    constructor(props) {
        super(props);
    }
    renderDateRange(start, end) {
        if (start == end) {
            return React.createElement("div", { "aria-describedby": "datePickerAddon", className: classNames("form-control") },
                " ",
                start,
                " ");
        }
        else {
            return React.createElement("div", { "aria-describedby": "datePickerAddon", className: classNames("form-control") },
                " ",
                start,
                " - ",
                end,
                " ");
        }
    }
    render() {
        const { fromDate, toDate } = this.props;
        //-- Convert display dates to strings
        let start = "";
        let end = "";
        if (fromDate && toDate) {
            start = moment(fromDate).format("DD MMMM YYYY");
            end = moment(toDate).format("DD MMMM YYYY");
        }
        return (React.createElement("div", { className: classNames(styles.datePickerButton, "input-group") },
            this.renderDateRange(start, end),
            React.createElement("span", { className: "input-group-addon fa fa-calendar", id: "datePickerAddon" })));
    }
}
